import { createRoute, lazyRouteComponent } from "@tanstack/react-router";

import { rootRoute } from "../__root";

export const userSignInRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/user/sign_in",
  component: lazyRouteComponent(
    () =>
      import(
        /* webpackChunkName: "SignInPage" */ "@circle-react/components/Discover/SignInPage"
      ),
    "SignInPage",
  ),
});
